import React from 'react';

const HandCard = ({ card, onClick, faceDown = false, isHighlighted = false }) => {
  const imageSrc = faceDown
    ? require('../assets/images/card-back.jpg')
    : card.card_images?.[0]?.image_url;

  return (
    <div className="hand-card-wrapper">
      <img
        onContextMenu={(e) => e.preventDefault()}
        onMouseDown={(e) => e.button === 2 && e.preventDefault()}
        onTouchStart={(e) => e.preventDefault()}
        draggable={false}
        src={imageSrc}
        alt={card.name}
        className={`hand-card ${isHighlighted ? 'highlight' : ''}`}  // ✅ use prop
        onClick={onClick}
      />
    </div>
  );
};


export default HandCard;
